import React from 'react'
import { VStack } from '@chakra-ui/react'
import { useSelector } from 'react-redux'

import DownloadPoints from './DownloadPoints'
import BaseMapList from './BaseMapList'
import InfoBox from './InfoBox'
import ChangelogBox from './ChangelogBox'

export default function MapControl() {
  const { verifyTokenPending, isAuthenticated } = useSelector(
    (state) => state.authStates,
  )
  return (
    <VStack position="absolute" left={'40px'} top={'50px'} zIndex="1000">
      <BaseMapList />
      <InfoBox />
      <ChangelogBox></ChangelogBox>
      {isAuthenticated && !verifyTokenPending ? <DownloadPoints /> : null}
    </VStack>
  )
}
